"use client"

import { useState } from "react"
import "./LegalFaq.css"

const faqData = [
  {
    question: "What is Legaltech?",
    answer:
      "LegalTech refers to using technology and software to provide legal services and support the legal industry. It encompasses many applications, from automating document analysis to providing more accessible legal services to the public.",
  },
  {
    question: "How does legaltech benefit lawyers and lawfirms?",
    answer:
      "LegalTech offers numerous benefits, including increased efficiency through automation, improved accuracy in legal research, enhanced client communication and service delivery, and the ability to quickly analyze large volumes of data. It also helps in reducing costs and improving the accessibility of legal services.",
  },
  {
    question: "Can legaltech help with compliance and regulatroy issues?",
    answer:
      "Yes, many LegalTech solutions are designed to assist with compliance and regulatory challenges. They can automate monitoring regulatory changes, ensure that documents and procedures comply with current laws, and reduce non-compliance risk through predictive analytics and compliance frameworks.",
  },
  {
    question:
      "What are soem common types of legaltech tools?",
    answer:
      "Common LegalTech tools include document management systems, e-discovery platforms, legal research tools, contract analysis software, practice management systems, and online dispute resolution platforms. These tools cater to various aspects of legal work, from case management to legal document analysis.",
  },
  {
    question: "How can digital healthcare solutions benefit my institution?",
    answer:
      "LegalTech is transforming the legal industry by making legal services more efficient, affordable, and accessible. It's enabling lawyers to focus on higher-value work by automating routine tasks, fostering innovation in legal services delivery, and creating new opportunities for legal professionals.",
  },
  {
    question: "How is legaltech changing the legal industries?",
    answer:
      "We prioritize patient data security and compliance with industry regulations. Our solutions are built with robust security measures to safeguard sensitive healthcare information.",
  },
  {
    question:
      "Are there any challenges in adopting legaltech?",
    answer:
      "The main challenges include the initial cost and effort of implementation, the learning curve associated with new technologies, concerns about data security and privacy, and the need for ongoing updates and maintenance. However, the long-term benefits often outweigh these challenges.",
  },
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section8569">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title">LEGAL TECHNOLOGY</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default FAQSection
